export default __webpack_public_path__ + "static/media/A3_b.ac513440.png";